import { type AnyAction, type Dispatch } from 'redux';
export const redirectOnErrorMiddleware =
  () =>
  (next: Dispatch) =>
  (action: AnyAction): void => {
    next(action);
  };

export default redirectOnErrorMiddleware;
